import React from "react";
import MenuItem from "@mui/material/MenuItem";
import GetAppIcon from "@mui/icons-material/GetApp";
import { Viewer } from "components/auth/types";
import { useSnackbar } from "components/haven-design/snackbar";
import { useInterestsTable } from "../interests-table/table-context";
import ToolbarButton from "./button";

type Props = {
  actionsButton?: boolean
  viewer: Viewer;
  closeMenu?: () => void;
  setShowCSVModal: (value: boolean) => void;
}

const DownloadCSVButton: React.FC<Props> =
({ actionsButton, closeMenu, setShowCSVModal }) => {
  const { totalSelectedInterests } = useInterestsTable();
  const { openSnackbar } = useSnackbar();
  const handleClick = () => {
    if (totalSelectedInterests === 0) {
      openSnackbar({ message: "Please select applicants and try again" });
      return;
    }
    setShowCSVModal(true);
    if (closeMenu) closeMenu();
  };

  return (
    <>
      {actionsButton ? (
        <MenuItem id="actions-export-csv" onMouseUp={handleClick}>
          Export {`(${totalSelectedInterests})`}
        </MenuItem>
      ) : (
        <ToolbarButton id="actions-export-csv" onClick={handleClick} width={42}>
          <GetAppIcon
            style={{
              fontSize: 18,
              margin: "11px 0px 0px 12px",
              color: "#B6B6B6",
            }}
          />
        </ToolbarButton>
      )}
    </>
  );
};
export default DownloadCSVButton;
